import { render } from "./BaseModalTemplate.vue?vue&type=template&id=51c56458"
import script from "./BaseModalTemplate.vue?vue&type=script&lang=js"
export * from "./BaseModalTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__